import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { Config } from '../config/config';


@Injectable()
export class HttpService extends Config {

    constructor(private _http: Http, private _router: Router) {
        super()
    }

    httpGet(url) {

        var accessToken: string = sessionStorage.getItem('accessToken');

        var api = this.apiEndPoint() + url;

        var headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('x-access-token', accessToken);

        return this._http.get(api, { headers: headers })
            .map((response: Response) => {

                var res: any = response;
                var json = JSON.parse(res._body);

                console.log('API::' + api + '\n');

                return json;
            })
    }

    httpPost(url, data) {

        var api = this.apiEndPoint() + url;

        var accessToken: string = sessionStorage.getItem('accessToken');

        var headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('x-access-token', accessToken);

        return this._http.post(api, JSON.stringify(data), { headers: headers })
            .map((response: Response) => {

                var res: any = response;
                var json = JSON.parse(res._body);

                console.log('API::' + api + '\n' +
                    'POST DATA::' + JSON.stringify(data) + '\n' +
                    'RESPONSE::' + JSON.stringify(json));

                return json;
            })
    }

    httpPostWithFile(url, postData, filesToUpload, fieldnames) {

        var api = this.apiEndPoint() + url;
        var accessToken: string = sessionStorage.getItem('accessToken');
        const formData: FormData = new FormData();

        let headers = new Headers();
        headers.append('x-access-token', accessToken);
        headers.append('enctype', 'multipart/form-data');

        for (let i = 0; i < filesToUpload.length; i++) {
            formData.append(fieldnames[i], filesToUpload[i][0], filesToUpload[i][0].name);
        }

        if (postData !== "" && postData !== undefined && postData !== null) {
            for (var property in postData) {
                if (postData.hasOwnProperty(property)) {
                    formData.append(property, postData[property]);
                }
            }
        }

        return this._http.post(api, formData, { headers: headers }).map((response: Response) => {
            var res: any = response;
            var json = JSON.parse(res._body);

            console.log('API::' + api + '\n' +
                'POST DATA::' + JSON.stringify(postData) + '\n' +
                'RESPONSE::' + JSON.stringify(json));

            return json;
        })
    }

}


// WEBPACK FOOTER //
// ./src/app/_services/http.service.ts